import { render, staticRenderFns } from "./inputModel.vue?vue&type=template&id=147bd60c&scoped=true&"
import script from "./inputModel.vue?vue&type=script&lang=js&"
export * from "./inputModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bd60c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147bd60c')) {
      api.createRecord('147bd60c', component.options)
    } else {
      api.reload('147bd60c', component.options)
    }
    module.hot.accept("./inputModel.vue?vue&type=template&id=147bd60c&scoped=true&", function () {
      api.rerender('147bd60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/goods/goods/components/goodsBase/components/sku/inputModel.vue"
export default component.exports